module.exports = __webpack_public_path__ + "img/emp_ch_volkmar_0.f8004518.png";